export function Empty({ icon = '∅', title = 'Sem dados', sub }) {
  return (
    <div className="empty">
      <div className="empty__icon">{icon}</div>
      <div className="empty__title">{title}</div>
      {sub && <div className="empty__sub">{sub}</div>}
    </div>
  );
}

export function Loading({ texto = 'Carregando…' }) {
  return (
    <div className="empty">
      <div className="spinner" style={{ margin: '0 auto' }} />
      <div className="empty__sub mt-1">{texto}</div>
    </div>
  );
}

export function Alert({ tipo = 'info', children }) {
  return <div className={`alert alert--${tipo}`}>{children}</div>;
}

export function Badge({ tipo = 'neutral', children }) {
  return <span className={`badge badge--${tipo}`}>{children}</span>;
}

export function KPI({ label, value, sub, variant = '' }) {
  return (
    <div className={`kpi ${variant ? 'kpi--' + variant : ''}`}>
      <div className="kpi__label">{label}</div>
      <div className="kpi__value">{value}</div>
      {sub && <div className="kpi__sub">{sub}</div>}
    </div>
  );
}

export function PageHeader({ title, sub, actions }) {
  return (
    <div className="page-header">
      <div>
        <h1>{title}</h1>
        {sub && <div className="page-header__sub">{sub}</div>}
      </div>
      {actions && <div className="page-header__actions">{actions}</div>}
    </div>
  );
}

// Mapeia status string para tipo de badge
export function StatusBadge({ status }) {
  const s = String(status || '').toLowerCase();
  const map = {
    rascunho: 'neutral', revisao: 'info', aprovado: 'success', estornado: 'danger',
    enviado: 'info', recebido_async: 'info', processando: 'info',
    aceito: 'success', rejeitado: 'danger', erro: 'danger',
    aberto: 'success', fechado: 'neutral', reaberto: 'warning',
    pendente: 'warning', resolvida: 'success', descartada: 'neutral',
    ativo: 'success', vencido: 'danger', a_vencer: 'warning',
  };
  return <Badge tipo={map[s] || 'neutral'}>{status || '—'}</Badge>;
}
